<div class="signin-page" [class.theme-inverted]="navState.inverted()">
  @if (!cacheReload) {
  <div class="signin-card">
    <div class="signin-logo-chip">
      <img [src]="getLogo()" alt="" />
    </div>
    <mir-sqrs-broadcast [login]="true"></mir-sqrs-broadcast>
    <form class="signin-form" role="form">
      <div class="signin-field">
        <input
          [placeholder]="'NIP'"
          class="signin-input"
          name="username"
          #username
          required
          placement="right"
          tooltip="Votre NIP ECA"
        />
      </div>
      <div class="signin-field">
        <input
          [placeholder]="'Mot de passe'"
          class="signin-input"
          name="password"
          #password
          ngModel
          required
          placement="right"
          tooltip="Mot de passe ECA"
          type="password"
        />
      </div>
      @if (!loading) {
      <button
        (click)="onSignin(username.value, password.value)"
        class="btn btn-primary btn-submit signin-btn"
        type="submit"
      >
        Connexion
      </button>
      } @if (loading) {
      <div class="signin-loading">
        <em class="fal fa-3x fa-spin fa-spinner"></em>
      </div>
      }
    </form>
    @if (pleaseCaptcha) {
    <div class="signin-captcha-warning">
      <em class="fal fa-exclamation-triangle"></em> Merci de valider le captcha.
    </div>
    }
    <div class="signin-captcha">
      <re-captcha
        #captchaElement
        (resolved)="resolved($event)"
        siteKey="6LfYJzEbAAAAAEAS1Rd-1rmBVCMtYDcTVCAI4JCO"
      ></re-captcha>
    </div>
    <a
      class="signin-forgot"
      href="https://mypassword.118-vaud.ch/public/forgottenpassword"
      >Mot de passe perdu ?</a
    >
  </div>
  } @if (cacheReload) {
  <div class="signin-card signin-reload">
    <h2>Mir est en cours de rechargement …</h2>
  </div>
  }
</div>
